import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';

class SpecTestsClosedCervicalFractureCPR extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_ClosedCervicalFractureCPR' name='Closed Cervical Fracture CPR' visible={false} flagged={this.props.flagged}>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} includeFlags={false} header='Closed Cervical Fracture CPR'/>);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCFRAGELT55 ) {
        flagCount++;
    }    
    if( state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCFRSINGLE === 'yes') {
        flagCount++;
    }
    if( state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCFRCONDINVOLVTRAUMA === 'yes') {
        flagCount++;
    }
    if( state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCFRACUTE === 'yes') {
        flagCount++;
    }
    if( state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCFRERVISIT === 'yes') {
        flagCount++;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'ClosedCervicalFractureCPR'),
        flagged: flagCount >= 4 ? true : false
    };
}

const connectedSpecTestsClosedCervicalFractureCPR = connect(mapStateToProps)(SpecTestsClosedCervicalFractureCPR);
export { connectedSpecTestsClosedCervicalFractureCPR as SpecTestsClosedCervicalFractureCPR };



